'use client';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useState, type ReactNode } from 'react';
import { NuqsAdapter } from 'nuqs/adapters/next/app';
import { AuthProvider } from '@medizzconnect/auth/provider';

interface ProvidersProps {
  children: ReactNode;
  locale: string;
  enableAuthProvider?: boolean;
}

export function Providers({ children, locale, enableAuthProvider = true }: ProvidersProps) {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 60 * 1000, // 1 Minute
            gcTime: 5 * 60 * 1000, // 5 Minuten
            refetchOnWindowFocus: false,
            retry: 1,
          },
          mutations: {
            retry: 0,
          },
        },
      }),
  );

  return (
    <AuthProvider locale={locale} enabled={enableAuthProvider}>
      <QueryClientProvider client={queryClient}>
        <NuqsAdapter>{children}</NuqsAdapter>
      </QueryClientProvider>
    </AuthProvider>
  );
}
